module.exports = __webpack_public_path__ + "i18n/tr.5b212e42d37b5abbaa6eecd723dea5e2.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/tr.json
// module id = 1292
// module chunks = 60